<aur-mat-table
  [tableConfig]="tableConfig"
  [tableData]="tableData"
  [paginatorState]="paginatorState"
  (pageChange)="loadPage($event)">
</aur-mat-table>
